import { Routes, ɵEmptyOutletComponent } from '@angular/router';
import { languages } from '../consts';
import { homeRedirectGuard } from '../guards/home-redirect.guard';
import { defaultLocaleGuard } from './guards/default-locale.guard';
import { isArticleGuard } from './guards/is-article.guard';
import { isNonDefaultLocaleGuard } from './guards/is-non-default-locale.guard';
import { isRedirectGuard } from './guards/is-redirect.guard';
import { isStoryGuard } from './guards/is-story.guard';
import { jsonLDDeactivateGuard } from './guards/json-ld-page-deactivate.guard';
import { storyblokPageJsonLDGuard } from './guards/storyblok-page-json-ld.guard';
import { storyblokPreventNavInEditModeGuard } from './guards/storyblok-prevent-nav-in-edit-mode.guard';
import { storyblokRedirectGuard } from './guards/storyblok-redirect.guard';
import { storyblokStoryGuard } from './guards/storyblok-story.guard';
import { storyblokAllowStickyHeaderResolver } from './storyblok-allow-sticky-header.resolver';
import { storyblokBackendPricesResolver } from './storyblok-backend-prices.resolver';
import { storyblokCompetitorsResolver } from './storyblok-competitors.resolver';
import { storyblokCustomRatingsResolver } from './storyblok-custom-ratings.resolver';
import { storyblokFooterResolver } from './storyblok-footer.resolver';
import { storyblokHeaderResolver } from './storyblok-header.resolver';
import { storyblokPageMetaResolver } from './storyblok-page-meta.resolver';
import { StoryblokPageComponent } from './storyblok-page/storyblok-page.component';
import { storyblokPricingBoxContentResolver } from './storyblok-pricing-box-content.resolver';
import { storyblokPricingTechnicalLinksResolver } from './storyblok-pricing-technical-links.resolver';
import { storyblokArticleTopicsResolver } from './storyblok-product-article-topics.resolver';
import { storyblokProductComparisonFeatureGroupsResolver } from './storyblok-product-comparison-feature-groups.resolver';
import { storyblokProductComparisonFeaturesResolver } from './storyblok-product-comparison-features.resolver';
import { storyblokProductsResolver } from './storyblok-products.resolver';
import { storyblokPromotionResolver } from './storyblok-promotion.resolver';
import { storyblokRelationshipsResolver } from './storyblok-relationships.resolver';
import { storyblokSeatAddonPricesResolver } from './storyblok-seat-addon-prices.resolver';
import { storyblokStoryResolver } from './storyblok-story.resolver';
import { storyblokToolsConvertFormatsResolver } from './storyblok-tools-convert-formats.resolver';
import { storyblokUpdates } from './storyblok-updates.resolver';

const allRoutes: Routes = [
  {
    path: 'home',
    canActivate: [homeRedirectGuard],
    component: ɵEmptyOutletComponent,
  },
  {
    path: '**',
    component: StoryblokPageComponent,
    canMatch: [isStoryGuard],
    canActivate: [storyblokStoryGuard, storyblokPageJsonLDGuard],
    canDeactivate: [storyblokPreventNavInEditModeGuard, jsonLDDeactivateGuard],
    resolve: {
      story: storyblokStoryResolver,
      backendPrices: storyblokBackendPricesResolver,
      seatAddonPrices: storyblokSeatAddonPricesResolver,
      pricingBoxContent: storyblokPricingBoxContentResolver,
      products: storyblokProductsResolver,
      productComparisonFeatureGroups: storyblokProductComparisonFeatureGroupsResolver,
      productComparisonFeatures: storyblokProductComparisonFeaturesResolver,
      articleTopics: storyblokArticleTopicsResolver,
      pricingTechnicalLinks: storyblokPricingTechnicalLinksResolver,
      promotion: storyblokPromotionResolver,
      relationships: storyblokRelationshipsResolver,
      toolConversionFormatList: storyblokToolsConvertFormatsResolver,
      customRatings: storyblokCustomRatingsResolver,
      competitors: storyblokCompetitorsResolver,
      updates: storyblokUpdates,
      footer: storyblokFooterResolver,
      header: storyblokHeaderResolver,
      allowStickyHeader: storyblokAllowStickyHeaderResolver,
      meta: storyblokPageMetaResolver(storyblokStoryResolver),
    },
  },
  {
    path: '**',
    canMatch: [isArticleGuard],
    loadChildren: () => import('./article-route').then(m => m.articleRoutes),
  },
  {
    path: '**',
    component: ɵEmptyOutletComponent,
    canMatch: [isRedirectGuard],
    canActivate: [storyblokRedirectGuard],
  },
];

export const routes: Routes = [
  {
    path: ':lang',
    canMatch: [isNonDefaultLocaleGuard(languages)],
    canActivate: [defaultLocaleGuard],
    children: allRoutes,
  },
  ...allRoutes,
];
